var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelBarbijoQuirurgico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.47 18.92C11.7292 18.92 12.75 17.8992 12.75 16.64C12.75 15.3808 11.7292 14.36 10.47 14.36C9.21079 14.36 8.19 15.3808 8.19 16.64C8.19 17.8992 9.21079 18.92 10.47 18.92Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.53 18.92C22.7892 18.92 23.81 17.8992 23.81 16.64C23.81 15.3808 22.7892 14.36 21.53 14.36C20.2708 14.36 19.25 15.3808 19.25 16.64C19.25 17.8992 20.2708 18.92 21.53 18.92Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.13 13.31C22.13 9.89689 19.3631 7.13 15.95 7.13C12.5369 7.13 9.77 9.89689 9.77 13.31V18.9C9.77 22.3131 12.5369 25.08 15.95 25.08C19.3631 25.08 22.13 22.3131 22.13 18.9V13.31Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.70001C10.55 5.70001 7 10.29 9.77 16.33C9.77 16.33 9.67 10 12.14 10C12.14 10 12.74 10.69 15.96 10.69C19.18 10.69 19.77 10 19.77 10C22.25 10 22.15 16.33 22.15 16.33C24.88 10.29 21.37 5.70001 16 5.70001Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.75C15.0927 25.7395 14.196 25.5527 13.36 25.2C11.9376 24.5042 10.7643 23.3868 10 22C9.47717 20.7289 9.40657 19.3169 9.80001 18C9.81505 17.9545 9.84283 17.9143 9.88006 17.8842C9.91729 17.8541 9.9624 17.8353 10.01 17.83C11.4976 17.7555 12.9349 17.2672 14.16 16.42C14.6897 16.0096 15.3311 15.7691 16 15.73C16.7186 15.766 17.4121 16.0053 18 16.42C19.2185 17.1716 20.5812 17.6588 22 17.85C22.0458 17.857 22.0888 17.8766 22.1241 17.9067C22.1594 17.9367 22.1857 17.9759 22.2 18.02C22.6193 19.3843 22.5486 20.8523 22 22.17C21.2526 23.4745 20.1261 24.5208 18.77 25.17C17.9005 25.5415 16.9655 25.7353 16.02 25.74L16 25.75Z",
    fill: "#75DDCA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C18 16.13 17.68 17.35 22 18.12C22.3877 19.4415 22.2992 20.8571 21.75 22.12C21.0265 23.3673 19.9471 24.3701 18.65 25C17.8074 25.3369 16.9074 25.5067 16 25.5C15.1259 25.4978 14.2602 25.3281 13.45 25C12.0864 24.3506 10.9503 23.3051 10.19 22C9.68107 20.7603 9.61399 19.3833 10 18.1C14.43 17.55 14 16.1 16 15.98V16ZM16 15.48C15.2713 15.5148 14.5719 15.7771 14 16.23C12.8192 17.0481 11.4344 17.5224 10 17.6C9.90399 17.6125 9.81351 17.652 9.73913 17.714C9.66476 17.776 9.60956 17.8578 9.57999 17.95C9.18327 19.3137 9.25367 20.7709 9.77999 22.09C10.5782 23.5429 11.8131 24.7079 13.31 25.42C14.1607 25.7855 15.0743 25.9824 16 26C16.9724 25.9961 17.9344 25.7989 18.83 25.42C20.2518 24.7445 21.4318 23.6483 22.21 22.28C22.7847 20.9257 22.88 19.4158 22.48 18C22.4522 17.9132 22.4011 17.8356 22.3324 17.7756C22.2637 17.7157 22.1798 17.6757 22.09 17.66C20.6712 17.4814 19.3072 17.0006 18.09 16.25C17.4803 15.8006 16.7555 15.5336 16 15.48Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.28 19.37C12.7615 18.7194 14.3619 18.3835 15.98 18.3835C17.5981 18.3835 19.1985 18.7194 20.68 19.37",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.22 20.72H20.66",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.63 22.22C14.4179 23.3248 17.5221 23.3248 20.31 22.22",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 10.09C14.56 11.41 17.67 12.38 16.51 11.19C16.4952 11.1705 16.4868 11.147 16.4857 11.1226C16.4847 11.0982 16.4911 11.0741 16.5042 11.0534C16.5172 11.0328 16.5362 11.0166 16.5587 11.007C16.5812 10.9975 16.6061 10.995 16.63 11C18.72 11.69 25.01 13.62 19.89 10.09",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 10.09C14.56 11.41 17.67 12.38 16.51 11.19C16.4952 11.1705 16.4868 11.147 16.4857 11.1226C16.4847 11.0982 16.4911 11.0741 16.5042 11.0534C16.5172 11.0328 16.5362 11.0166 16.5587 11.007C16.5812 10.9975 16.6061 10.995 16.63 11C18.72 11.69 25.01 13.62 19.89 10.09",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelBarbijoQuirurgico);
export default __webpack_public_path__ + "static/media/SelBarbijoQuirurgico.d04e8b43b3101c02f73c39585dedb828.svg";
export { ForwardRef as ReactComponent };